import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionsLogin } from '../../actions';
import { ComponentsLoginForm } from "../../components/Login/Form";
import { ServiceLogin } from "../../service/Login";
import { Messages } from 'primereact/messages';
import { ServiceMessage } from "../../service/Message";
import { ComponentsAppSplash } from "../../components/App/Splash";
import { HistoricoAceiteLGPD } from '../../service/HistoricoAceiteLGPD';
import { ScreensLGPDForm } from '../LGPD/Form';
import { ServiceApi } from "./../../service/Api";

class ScreensLoginMedicoSolicitanteForm extends Component {

    constructor() {

        window.globalVars.acessoMedicoSolicitante = true;

        super();

        this.state = {
            splash: false,
            objLGPD: { NomeUsuario: '', Exibir: false }
        };

        this.aceiteLGPD = localStorage.getItem('AceiteLGPD') === 'SIM';
        this.historicoAceiteLGPD = new HistoricoAceiteLGPD();
        this.serviceLogin = new ServiceLogin();

        // Acesso via QR Code
        var acesso_qrcode = window.location.hash;
        acesso_qrcode = acesso_qrcode.split("=");
        if (acesso_qrcode[1]) {
            var post = { usuario: acesso_qrcode[1].replace("&pass", ""), senha: acesso_qrcode[2] };
            this.handleExecute(post);
        }

    }


    handleExecute(e) {

        this.setState({ splash: true });

        ServiceApi._getCnpj().then(cnpjCliente => {

        this.serviceLogin.login(e.usuario, e.senha, cnpjCliente)
            .then(response => {

                if (this.aceiteLGPD === false)
                    return this.setState({ objLGPD: { Usuario: this.getDadosUsuario(response), Exibir: true } });

                window.location = "#/portal";
            })
            .catch(err => {
                ServiceMessage.warn('Código do médico ou senha inválidos!');
            })
            .finally(() => { this.setState({ splash: false }); });
        });
    }

    componentDidMount() {
        if (sessionStorage.getItem('auth'))
            this.historicoAceiteLGPD.ChecarAceiteLGPD();
    }

    getDadosUsuario(data) {
        return {
            Nome: data.Nome,
            AcessoDTO: {
                UsuarioId: data.Id,
                Perfil: 'Medico',
                DadosAcesso: ''
            }
        }
    }

    render() {

        return (
            <div>
                <ScreensLGPDForm objLGPD={this.state.objLGPD} />
                <ComponentsAppSplash visible={this.state.splash} />
                <Messages ref={(el) => this.messages = el} />
                <ComponentsLoginForm
                    onExecute={this.handleExecute.bind(this)} exibirTipo={false}
                ></ComponentsLoginForm>
            </div>
        );

    }
}

export default (ScreensLoginMedicoSolicitanteForm);